<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item :label="$l('table_head_chineseName') || '中文名称'" prop="prjAttributeName">
            <el-input
              v-model="formData.prjAttributeName"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item :label="$l('tips_englishName') || '英文名称'" prop="prjAttributeNameEn">
            <el-input
              v-model="formData.prjAttributeNameEn"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item :label="$l('tips_propertyType') || '属性类型'" prop="prjAttributeType">
            <el-input
              v-model="formData.prjAttributeType"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12">
          <el-form-item :label="$l('INDEX.Status') || '状态'" prop="prjAttributeStatus">
            <el-radio-group style="width: 100%" size="small" disabled v-model="formData.prjAttributeStatus">
              <el-radio label="Y">{{
                $l("INDEX.form_label_valid") || "有效"
              }}</el-radio>
              <el-radio label="N">{{
                $l("INDEX.form_label_invalid") || "无效"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24">
          <el-form-item :label="$l('table_label_description') || '属性说明'" prop="prjAttributeDescription">
            <el-input
              type="textarea"
              v-model="formData.prjAttributeDescription"
              maxlength="200"
              :disabled="disabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataVisible">
          <div style="font-size: 14px; color: #717171;">
            <span>Create：{{formData.createByName?formData.createByName:'--'}} at {{formData.createDate?formData.createDate:'--'}}</span>
            <br/>
            <span>Modify：{{formData.modifyByName?formData.modifyByName:'--'}} at {{formData.modifyDate?formData.modifyDate:'--'}}</span>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button @click="close()" size="small">{{
          this.$l("INDEX.btn_no_save") || "不保存"
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          this.$l("INDEX.btn_save") || "保存"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";

export default {
   props: {
    disabled: Boolean,
    prjAttributeCode: String,
    createDataVisible: Boolean,
  },
  data () {
    return {
      backDialogVisible: false,
      formData: {
        prjAttributeCode: '',
        prjAttributeType: '',
        prjAttributeName: '',
        prjAttributeNameEn: '',
        prjAttributeStatus: 'Y',
        prjAttributeDescription: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      },
      rules: {
        prjAttributeType: [
          { required: true, message: '请输入属性类型', trigger: 'blur' },
          { max: 50, message: '长度在50个字符以内', trigger: 'blur' }
        ],
        prjAttributeNameEn: [
          { required: true, message: '请输入中文名称', trigger: 'blur' },
          { max: 100, message: '长度在100个字符以内', trigger: 'blur' }
        ],
        prjAttributeName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' },
          { max: 100, message: '长度在100个字符以内', trigger: 'blur' }
        ],
        prjAttributeDescription: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { max: 2000, message: '长度在2000个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.prjAttributeCode) return;
      this.$api
        .prjDictionaryDetailApi({
          prjAttributeCode: this.prjAttributeCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    // 保存数据
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);
      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$api
        .prjDictionarySaveApi(this.formData)
        .then(() => {
          loadingInstance.close();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || "保存成功",
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          loadingInstance.close();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
    // 加载表单数据（新增，编辑，详情）
    // fromLoad (ref, val = '') {
    //   this.init()
    //   if (ref !== 'add') {
    //     this.createDataDisabled = true
    //     let param = { prjAttributeCode: val }
    //     this.$api.prjDictionaryDetailApi(param).then(res => {
    //       this.formData = res.body
    //     })
    //     // 控制组件不可编辑
    //     if (ref === 'detail') {
    //       this.disabled = true
    //     }
    //   }else{
    //     this.reset()
    //     this.createDataDisabled = false
    //   }
    // },
    // 保存数据
    // save () {
    //   // 校验表单正确性
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.$api.prjDictionarySaveApi(this.formData)
    //         .then(res => {
    //           this.$message({
    //             showClose: true,
    //             message: '保存成功',
    //             type: 'success'
    //           })
    //           // 通知父组件保存成功
    //           this.$emit('success')
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },
  }
}
</script>
